export const listUsersQuery = /* GraphQL */ `
query ListUsers($limit: Int, $nextToken: String) {
  listUsers(limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      displayName
      bio
      avatar
      verified
      createdAt
      updatedAt
    }
    nextToken
  }
}
`;

export const getUserQuery = /* GraphQL */ `
query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    username
    displayName
    bio
    avatar
    coverPhoto
    website
    location
    verified
    followersCount
    followingCount
    postsCount
    createdAt
    updatedAt
  }
}
`;

export const getUserByUsernameQuery = /* GraphQL */ `
  query userByUsername($username: String!) {
    userByUsername(username: $username) {
      items {
        id
        username
        email
        displayName
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        titles
        titleOrder
        activeBadges
        badgeDisplaySettings
        createdAt
        updatedAt
        followers { items { followerID } }
      }
      nextToken
    }
  }
`;

export const createUserMutation = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id username displayName bio avatar website location
      createdAt updatedAt
    }
  }
`;

export const updateUserMutation = /* GraphQL */ `
mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id 
    username 
    displayName 
    bio 
    avatar 
    coverPhoto
    website 
    location
    interests
    languagePreferences
    watchlistPublic
    titles
    titleOrder
    activeBadges
    badgeDisplaySettings
    createdAt 
    updatedAt
  }
}
`;

export const getUserByEmailQuery = /* GraphQL */ `
  query getUserByEmail($email: String!) {
    listUsers(filter: { email: { eq: $email } }) {
      items {
        id
        username
        email
        displayName
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        titles
        titleOrder
        activeBadges
        badgeDisplaySettings
        createdAt
        updatedAt
        followers { items { followerID } }
      }
      nextToken
    }
  }
`;



export const searchUsersQuery = /* GraphQL */ `
query SearchUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      username_lowercase
      displayName
      displayName_lowercase
      bio
      avatar
      website
      location
      verified
      followersCount
      followingCount
      createdAt
      updatedAt
      followers { items { followerID } }
    }
    nextToken
  }
}
`;